/* tslint:disable */
/* eslint-disable */
// Generated by Microsoft Kiota
// @ts-ignore
import { IntegrationsRequestBuilderNavigationMetadata, IntegrationsRequestBuilderRequestsMetadata, type IntegrationsRequestBuilder } from './integrations/index.js';
// @ts-ignore
import { type BaseRequestBuilder, type KeysToExcludeForNavigationMetadata, type NavigationMetadata } from '@microsoft/kiota-abstractions';

/**
 * Builds and executes requests for operations under /api/organizations/{organizationId}
 */
export interface WithOrganizationItemRequestBuilder extends BaseRequestBuilder<WithOrganizationItemRequestBuilder> {
    /**
     * The integrations property
     */
    get integrations(): IntegrationsRequestBuilder;
}
/**
 * Uri template for the request builder.
 */
export const WithOrganizationItemRequestBuilderUriTemplate = "{+baseurl}/api/organizations/{organizationId}";
/**
 * Metadata for all the navigation properties in the request builder.
 */
export const WithOrganizationItemRequestBuilderNavigationMetadata: Record<Exclude<keyof WithOrganizationItemRequestBuilder, KeysToExcludeForNavigationMetadata>, NavigationMetadata> = {
    integrations: {
        requestsMetadata: IntegrationsRequestBuilderRequestsMetadata,
        navigationMetadata: IntegrationsRequestBuilderNavigationMetadata,
    },
};
/* tslint:enable */
/* eslint-enable */
